/**
 * Envia um erro de runtime do CLIENTE para a rota de log via navigator.sendBeacon
 * (fire-and-forget, sobrevive à navegação).
 *
 * Dedup: erros de servidor possuem `digest` e já são capturados pelo
 * instrumentation.onRequestError — por isso só reportamos quando NÃO há digest
 * (erro de origem puramente client).
 */
export function reportClientError(error: { message?: string; stack?: string; digest?: string } | null | undefined) {
  try {
    if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") return;
    if (error?.digest) return; // já capturado server-side

    const payload = JSON.stringify({
      eventType: "RUNTIME_ERROR",
      accessedPath: window.location.pathname,
      errorMessage: error?.message ?? "Erro de cliente desconhecido",
      errorStack: error?.stack,
    });

    navigator.sendBeacon("/api/log/event", new Blob([payload], { type: "application/json" }));
  } catch {
    // best-effort
  }
}

/**
 * Reporta um 404 a partir do cliente, quando a página not-found é DE FATO exibida
 * ao usuário (montada no DOM). Necessário porque o Next renderiza `not-found.tsx`
 * como boundary de fallback em toda página — capturar no render do servidor geraria
 * falso-positivo em rotas válidas. No cliente, o efeito só roda quando o 404 é montado.
 */
export function reportNotFound() {
  try {
    if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") return;
    const payload = JSON.stringify({
      eventType: "NOT_FOUND",
      statusCode: 404,
      accessedPath: window.location.pathname,
    });
    navigator.sendBeacon("/api/log/event", new Blob([payload], { type: "application/json" }));
  } catch {
    // best-effort
  }
}
